import { render } from "./NfcSnackbar.vue?vue&type=template&id=59c29cd3"
import script from "./NfcSnackbar.vue?vue&type=script&lang=js"
export * from "./NfcSnackbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__